import { Account } from 'types/account';
import { Organization } from 'types/organization';

export function isBillingAccount(
  account: Account | null | undefined,
  organizationId: Organization['id']
) {
  if (!account) {
    return false;
  }

  return account.roles.some(
    ({ name, organization_id }) =>
      name === 'billing' &&
      (organization_id === organizationId ||
        // FIXME: backward compatibility
        organization_id === undefined)
  );
}
